<template>
  <div data-qa="service-details-content">
    <BaseAlert
      v-if="!servicesData.is_doctor_work_at_lpu"
      data-qa="service-details-content_not_is_doctor_work_at_lpu"
      color="text-secondary"
      :class="isMobile ? 'mb-4' : 'mb-5'"
      :text="t('Врач больше не работает в клинике, где выполнял услуги. Цена может отличаться.', optionsLang)"
    />
    <div
      v-for="(service, index) in servicesData.results"
      :key="index"
      :class="{ 'mt-4': index !== 0 }"
      data-qa="service-details-content_service"
    >
      <div
        v-if="service.name"
        data-qa="service-details-content_service_name"
        class="text-body-1 text--text mb-2"
      >
        {{ service.name }}
      </div>
      <div
        v-if="service.category"
        data-qa="service-details-content_service_category"
        class="text-body-2 text-secondary--text mb-2"
      >
        {{ service.category }}
      </div>
      <div class="d-flex flex-wrap align-center mt-2">
        <span
          data-qa="service-details-content_service_price"
          class="service-details-content-item text-subtitle-2 text--text"
        >{{ getFormattedPrice(service.quantity * service.price) }}</span>
        <span
          v-if="service.quantity > 1"
          data-qa="service-details-content_service_quantity"
          class="service-details-content-item text-body-2 text-info--text"
        >{{ service.quantity }} х {{ getFormattedPrice(service.price) }}</span>
        <span
          v-if="service.dt_last_price"
          data-qa="service-details-content_service_dt_last_price"
          class="service-details-content-item text-body-2 text-info--text"
        >{{ t('цена на', optionsLang) }} {{ getDate(service.dt_last_price) }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import I18NextVue from 'i18next'
import { format } from 'date-fns'
import { ru } from 'date-fns/locale'
import getFormattedPrice from 'www/utils/get/getFormattedPrice'
import { ApiDoctorCaseServicesResponseGet } from 'www/vue_components/common/DoctorCases/api/apiDoctorCaseServices.types'
import BaseAlert from 'www/vue_components/common/core/BaseAlert.vue'

defineProps<{
  servicesData: ApiDoctorCaseServicesResponseGet
}>()

const { t, language } = I18NextVue
const optionsLang = { ns: language }

const isMobile = window.MOBILE_VERSION

function getDate(dateString: string) {
  return format(new Date(dateString), 'dd.MM.yyyy', { locale: ru })
}
</script>

<style lang="scss" scoped>
.service-details-content-item {
  white-space: nowrap;

  &:not(:first-child)::before {
    content: '•';
    margin-left: 8px;
    margin-right: 8px;
  }
}
</style>
